module.exports = __webpack_public_path__ + "static/media/Insurance-Example.2dc86efd.png";